import styled from "styled-components";

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Row = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`;

export const AvatarButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: block;
  line-height: 0;
  padding: 0;
`;

export const RowText = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
  padding: 0;
  text-align: left;
`;

export const NameLine = styled.span`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 13px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SubLine = styled.span`
  color: ${({ theme }) => theme.colors.chalk};
  font-size: 11.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FollowButtonSlot = styled.div`
  flex-shrink: 0;
`;
